import type { FaireProductEntity } from "../../entity_types/product";

export const p_buuwu3wn44: FaireProductEntity = {
  token: "p_buuwu3wn44",
  type: "product",
  name: "Colombo Dinner Plate Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/3b6b78f3a639fa0ff0860dd09ae5c148188e29d49f5425f2cb4aab2b4360eac5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b73e0cd37a25445818a5e77bcb32d4639c189167cec3225f5b54f6d166e54829.jpeg",
    "https://cdn.faire.com/fastly/4c930b3ea3f8b74b53e150b46c1ffb7460b1c11e2170240ba1ca2ef9bc36f5eb.jpeg",
    "https://cdn.faire.com/fastly/edb7523487f33a8a2e2233565c77556dee52ab17aec317a075f04ba98521b52e.jpeg",
    "https://cdn.faire.com/fastly/8f98657bd7880c257c1f3f8877b7e3e8fc641a67ad85479d7f7bb25ee1a2a980.jpeg",
    "https://cdn.faire.com/fastly/3c85bc784b19fc0d653673f6f25fd4393e5fcd5de5995eea7af7656ed4ca727c.jpeg",
    "https://cdn.faire.com/fastly/df9c00de95560a83e23081e1141e6401be2cb6620ef143784f6ce77e9f07d5b3.jpeg",
    "https://cdn.faire.com/fastly/608171342426cd2a95302c5faf6e415579534f25b71fdf28c455babf5fba905c.jpeg",
    "https://cdn.faire.com/fastly/67190d748bd4e3426e4edcdcbb415db611b3dcbd9f48432bc1d72c84cb0cc691.jpeg",
    "https://cdn.faire.com/fastly/95d7f3aacaddbe34621ec57281592792d91cbc3c436094ae5296fc0c6e4fd937.jpeg",
    "https://cdn.faire.com/fastly/1cc4168aa2d8b97a5a93dc935c7abc46cf2e884d58e42ad83ff0939415b8c2b7.jpeg",
    "https://cdn.faire.com/fastly/d50c55b538feb9a1f86d6bc9e5f7382ecf4c224c5571a2154c78043c4a393ba9.jpeg",
    "https://cdn.faire.com/fastly/cc98e3c5368ce24453c975489b119a3d1b038c9531a94f567107a5f31a2efb89.jpeg",
    "https://cdn.faire.com/fastly/56825772950a8acc231bee9108ae18b293af9969d515ec7e7a43e650b93cf613.jpeg",
  ],
  priceDollars: 35,
  description:
    'Colombo is a pleasing dinnerware range inspired by our love of sharing food with friends and family and creating memories around the table.\n\nThe well-considered collection of plates and bowls is perfect for hosting a dinner party for larger group and for making everyday meals for your loved ones special.\n\nColombo range allows you to be creative in how you set your table to best accompany your dishes, mood and needs.\n\nYou can match the colours across the range or mix them, to create your own unique set and add a curated eclectic feel to your table.\n\nBeautifully handcrafted from coloured porcelain – a superior strong and hardwearing ceramic, that if cared for, should last a lifetime. Dishwasher and microwave-safe.\n\nColombo dinner plate is great for everyday meals and for serving sharing dishes.\n\n• Material: Porcelain\n• Size: 25 x 2 cm / 9.8 x 0.8"\n• Set of 2',
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:35.004Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
